// extracted by mini-css-extract-plugin
export default {"wrapper":"YwX3zIH"};